/**
 * LocalImageThumb — thumbnail for a file the user just picked, before upload.
 *
 * Browsers disagree on HEIC: Safari draws it, Chrome/Edge/Firefox do not. So
 * every file gets a real preview URL and the <img> decides: when it cannot
 * decode, the tile falls back to a label (the file's extension, e.g. "HEIC")
 * instead of a broken image. The server stores JPEG once it is uploaded.
 */
import React, { useState } from 'react';

function extLabel(name) {
  const ext = (name || '').split('.').pop();
  return ext && ext !== name ? ext.toUpperCase().slice(0, 5) : 'IMAGE';
}

export default function LocalImageThumb({ src, name, alt = '', className = '', fallbackClassName = '' }) {
  // Remember WHICH src failed, so picking a new file after a HEIC does not
  // inherit the fallback (E2E caught this: HEIC then PNG kept showing "HEIC").
  const [brokenSrc, setBrokenSrc] = useState(null);
  const broken = !!src && brokenSrc === src;
  if (!src || broken) {
    return (
      <div
        className={`flex items-center justify-center bg-slate-100 dark:bg-white/5 text-[10px] font-medium text-slate-500 ${className} ${fallbackClassName}`}
        title={name}
        data-testid="local-image-thumb-fallback"
      >
        {extLabel(name)}
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} onError={() => setBrokenSrc(src)} />;
}
